<template>
  <div class="container mx-auto my-10 p-4">
    <div class="w-full flex place-content-center">
      <div class="w-1/2 p-4 text-center">
        <div class="card-header p-4">
          <h2 v-if="language =='en'">Survey</h2>
          <h2 v-else>参加调查</h2>
        </div>
        <div class="card-body p-4">
          <div class="flex flex-wrap bg-white rounded-md py-6 px-custom" v-if="step == 0">
            <RangeSlider
              class="mb-10"
              :language='language'
              :options="language == 'en' ? optionsAgreeDisagree : optionsAgreeDisagreeZh"
              :title="language == 'en' ? 'The app was user-friendly and easy to navigate' : '问卷APP使用很简单方便'"
              v-model="surveyResults.user_friendly"
            />
          </div>

          <div class="flex flex-wrap bg-white rounded-md py-4 px-custom" v-if="step == 1">
            <RangeSlider
              class="mb-10"
              :language='language'
              :options="language == 'en' ? optionsSatisfied : optionsSatisfiedZh"
              :title="language == 'en' ? 'I am satisfied with the information provided about My New Life' : '我对 新生活 提供的信息满意'"
              v-model="surveyResults.satisfied_info"
            />
          </div>

          <div class="flex flex-wrap bg-white rounded-md py-4 px-12" v-if="step == 2">
            <RangeSlider
              class="mb-10"
              :language='language'
              :options="language == 'en' ? optionsAgreeDisagree : optionsAgreeDisagreeZh"
              :title="language == 'en' ? 'I like the offering of a personalised solution for my health condition based on a self-assessment' : '我欣赏这种为基于自评，对我的个人健康状况定制方案的方式'"
              v-model="surveyResults.like_offering"
            />
          </div>

          <div class="flex flex-wrap bg-white rounded-md py-4 px-12" v-if="step == 3">
            <RangeSlider
              class="mb-10"
              :language='language'
              :options="language == 'en' ? optionsAgreeDisagree : optionsAgreeDisagreeZh"
              :title="language == 'en' ? 'I approve of this product & am likely to buy it' : '我认同这种产品并有可能购买'"
              v-model="surveyResults.approve_product"
            />
          </div>

          <div class="flex flex-wrap bg-white rounded-md py-4 px-12" v-if="step == 4">
            <TextInput
              type="textarea"
              class="w-full"
              :title="language == 'en' ? 'Other customer feedback (on the app features & information provided)' : '其他客户反馈（基于APP特征及提供的信息）'"
              v-model="surveyResults.other_feedback"
            />
          </div>

          <h2 v-if="step==5" id="form-title">Thank You!</h2>

          <Button
            class="w-full"
            v-if="step < 4"
            type="submit"
            id="register-submit"
            :label="language == 'en' ? 'Next' : '下一步'"
            v-on:click="step++"
          />

          <Button
            class="w-full"
            v-if="step == 4"
            type="submit"
            id="goto-questions"
            :label="language == 'en' ? 'Submit' : '继续'"
            v-on:click="submitSurvey"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      step: 0,
      surveyResults: {
        user_friendly: null,
        satisfied_info: null,
        like_offering: null,
        approve_product: null,
        other_feedback: null
      },
      optionsAgreeDisagree: [
        { label: "Strongly Disagree", value: "Strongly Disagree" },
        { label: "Disagree", value: "Disagree" },
        { label: "Neutral", value: "Neutral" },
        { label: "Agree", value: "Agree" },
        { label: "Strongly Agree", value: "Strongly Agree" }
      ],
      optionsAgreeDisagreeZh: [
        { label: "非常不同", value: "非常不同" },
        { label: "不同意", value: "不同意" },
        { label: "一般", value: "一般" },
        { label: "同意", value: "同意" },
        { label: "常同意", value: "常同意" }
      ],
      optionsSatisfied: [
        { label: "Not satisfied", value: "Not satisfied" },
        { label: "Slightly satisfied", value: "Slightly satisfied" },
        { label: "Moderately satisfied", value: "Moderately satisfied" },
        { label: "Very satisfied", value: "Very satisfied" },
        { label: "Completely satisfied", value: "Completely satisfied" }
      ],
      optionsSatisfiedZh: [
        { label: "完全不满意", value: "完全不满意" },
        { label: "部分满", value: "部分满" },
        { label: "一般满意", value: "一般满意" },
        { label: "非常满意", value: "非常满意" },
        { label: "极其满意", value: "极其满意" }
      ]
    };
  },
  methods: {
    submitSurvey() {
      this.step++;
      axios.post("/survey", this.surveyResults).then(resp => {
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 250);
      });
    }
  },
  computed: {
    ...mapGetters({
      language: "clientLanguage"
    })
  }
};
</script>

<style>
#form-title {
  margin-top: 0;
  font-weight: 400;
  text-align: center;
  color: #88ad3f;
  margin-bottom: 20px;
}

.px-custom {
  padding-left: 2rem;
  padding-right: 4rem;
}

@media screen and (max-width: 1023px) {
  .w-1\/2 {
    width: 100%;
  }
}

@media screen and (max-width: 599px) {
  .px-custom {
    height: 450px;
    padding: 2rem;
  }
}
</style>
